import * as React from 'react';
import { useSiteMetadata } from 'hooks';
import { GatsbyProps } from 'models/gatsby-props';

interface Props extends GatsbyProps {
    title: string;
    description: string;
    pathname: string;
    image?: string;
}

export const Seo = ({ title, description, pathname, image, children }: Props) => {
    const { title: defaultTitle, description: defaultDescription, image: defaultImage, siteUrl } = useSiteMetadata();

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image || defaultImage}`,
        url: `${siteUrl}${pathname || ''}`
    };

    return (
        <>
            <html lang="en" />
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:url" content={seo.url} />
            <meta property="og:site_name" content="Elumity" />
            <meta property="og:image" content={seo.image} />
            <meta property="og:image:alt" content="Blog Thumbnail" />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:url" content={seo.url} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            {children}
        </>
    );
};
